import React from "react";
import ContactForm from "../ContactForm/ContactForm";
import "./Footer.css";
import { User } from "firebase/auth";
import { useTranslation } from "react-i18next";

type FooterProps = {
  user: User | null;
};

const Footer: React.FC<FooterProps> = ({ user }) => {
  const { t } = useTranslation() as { t: (key: string) => string };

  return (
    <footer className="footer">
      <div className="footer_container">
        <h2 id="contactUs">{t("contactUs")}</h2>
        {user ? (
          <ContactForm />
        ) : (
          <p style={{ opacity: 0.6 }}>{t("pleaseLogInToContactUs")}</p>
        )}
        <p className="footer_note">© {new Date().getFullYear()} Flermo</p>
      </div>
    </footer>
  );
};

export default Footer;
